import { useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { Link, useParams } from 'react-router-dom';
import { Alert, Button, CircularProgress, Pagination, TextField } from '@mui/material';
import Box from 'elements/Box';
import { ProjectConfig } from 'Global';

export default function SantoralCatalogList() {
  const { category } = useParams();
  const [list, setList] = useState<any[]>([]);
  const [name, setName] = useState('');
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true); setError('');
    const timer = window.setTimeout(() => {
      axios.get(ProjectConfig.api_url, {
        params: { request: 'santoral_catalog_admin_list', category, name, page, lang_id: '1' },
        headers: { Authorization: `Bearer ${new Cookies().get('ltkn') || ''}` },
        signal: controller.signal, timeout: 20000,
      }).then(response => {
        setList(response.data.list || []); setPages(response.data.total_pages || 1);
      }).catch(err => { if (!controller.signal.aborted) setError(err?.response?.data?.message || 'No se pudo cargar el santoral.'); })
        .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    }, 250);
    return () => { window.clearTimeout(timer); controller.abort(); };
  }, [category, name, page]);
  return <div id="ProductList">
    <div className="buttons_top"><Button component={Link} to="/admin/santoral">Volver al Santoral</Button></div>
    <Box id="santoral_catalog_list" title={category === 'hsf' ? 'Hijos de la Sagrada Familia' : 'Martirologio Romano'} subtitle="Editar fichas publicadas">
      <TextField label="Buscar" value={name} onChange={event => { setName(event.target.value); setPage(1); }} fullWidth />
      {error && <Alert severity="error">{error}</Alert>}
      {loading ? <CircularProgress /> : <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 16 }}>
        {list.map(entry => <Button key={entry.id} variant="outlined" component={Link} to={`/admin/santoral/catalogo/${category}/edit/${encodeURIComponent(entry.id)}`} sx={{ justifyContent: 'space-between', textAlign: 'left', padding: 2 }}>
          <span>{entry.name}</span><span>{entry.month && entry.day ? `${entry.day}/${entry.month}` : ''}</span>
        </Button>)}
        {!list.length && <p>No se encontraron fichas.</p>}
      </div>}
      <Pagination count={pages} page={page} onChange={(_, value) => setPage(value)} sx={{ marginTop: 2 }} />
    </Box>
  </div>;
}
